import { useParams } from "react-router-dom";
import Hero from "../../components/Hero";
import Offers from "../../features/web/coursesAndOffers/OffersPage";
import MetaTags from "../../components/MetaTags";
function AllOffers() {
    const { grade } = useParams();
    let year;
    if (grade === "1") {
        year = "الصف الأول الثانوي";
    }
    if (grade === "2") {
        year = "الصف الثاني الثانوي";
    }
    if (grade === "3") {
        year = "الصف الثالث الثانوي";
    }
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | العروض"
                description="صفحة العروض على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض جميع العروض لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <Hero
                title="مادة اللغة العربية"
                description={year}
                pagesLinks={[
                    { name: `العروض`, link: `/${grade}/offers` },
                    { name: "الصفحة الرئيسية", link: "/" },
                    { name: `${year}`, link: `/${grade}/courses` },
                ]}
            />

            <Offers />
        </>
    );
}

export default AllOffers;
